// Style your elements here
import styled from 'styled-components'

export const Li = styled.li``
export const Button = styled.button`
  background-color: #ededed;
  opacity: ${prop => (prop.opaci ? 1 : 0.5)};
  color: black;
  text-alien: center;
  padding: 3px;
  width: 80px;
  border: none;
  margin: 3px;
`
